import React from 'react';
import Text from '../text/Text';
import { Event } from './types';

function EventCard({ event }: { event: Event }) {
  return (
    <div>
      <Text size="xl" weight="semibold">
        {event.label}
      </Text>
      <div>
        <Text size="lg">{event.date}</Text>
      </div>
    </div>
  );
}

export default EventCard;
